import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agentsApi, AIAgentResponse } from '../services/agentsApi';
import { toast } from 'sonner';

/**
 * Hook para atualizar status do agente (ativar/desativar)
 *
 * @example
 * const updateStatus = useUpdateAgentStatus();
 *
 * const handleToggleStatus = async (agentId: string, newStatus: 'active' | 'inactive') => {
 *   try {
 *     await updateStatus.mutateAsync({ id: agentId, status: newStatus });
 *   } catch (error) {
 *     // Error já tratado automaticamente
 *   }
 * };
 */
export const useUpdateAgentStatus = () => {
  const queryClient = useQueryClient();

  return useMutation<AIAgentResponse, Error, { id: string; status: 'active' | 'inactive' }>({
    mutationFn: ({ id, status }) => agentsApi.updateStatus(id, status),
    onSuccess: (data) => {
      // Invalidate queries para refetch
      queryClient.invalidateQueries({ queryKey: ['ai-agents'] });
      queryClient.invalidateQueries({ queryKey: ['ai-agent', data.id] });

      const message = data.status === 'active'
        ? 'Agente ativado com sucesso!'
        : 'Agente desativado com sucesso!';
      toast.success(message);
    },
    onError: (error) => {
      toast.error(`Erro ao atualizar status: ${error.message}`);
    },
  });
};
